import request from "../utils/request";

/**
 * 获取用户关注专题
 * @param {number} urlname 用户urlname
 * @returns
 */
export async function getFollowingExplores({ urlname, page, per_page }) {
  return request({
    url: `/${urlname}/following/explores`,
    query: {
      page,
      per_page,
    },
    noParse: true,
  });
}

/**
 * 关注专题
 * @param {number} urlname 专题urlname
 * @returns
 */
export async function followExplore(urlname) {
  return request({
    method: "post",
    url: `/explore/${urlname}/follow`,
    noParse: true,
  });
}

/**
 * 取消关注专题
 * @param {number} urlname 专题urlname
 * @returns
 */
export async function unfollowExplore(urlname) {
  return request({
    method: "post",
    url: `/explore/${urlname}/unfollow`,
    noParse: true,
  });
}

/**
 * 批量获取专题
 * @param {string[]} urlnames 专题urlnames
 * @returns
 */
export async function batchGetExplores({ urlnames }) {
  return request({
    url: "/explore/batch",
    query: {
      urlnames,
    },
  });
}

/**
 * 获取用户关注专题
 * @param {urlname:number} urlname 用户urlname
 * @returns
 */
export async function getTopicDetail({
  urlname,
  preview_limit,
  preview_cache,
  preview_material,
}) {
  return request({
    url: `/topics/${urlname}`,
    noParse: true,
    query: {
      preview_limit,
      preview_cache,
      preview_material,
    },
  });
}

/**
 * 搜索相似专题
 * @param {{
 *  q: string,
 *  exclude_topic: string[] | string
 *  per_page: number
 *  page: number,
 *  dedupe:number
 * }} query
 * @returns {Promise<{result: any[], total:number}>}
 */
export async function searchTopic({
  q,
  per_page,
  page,
  exclude_topic,
  dedupe,
}) {
  return request({
    url: "/search/topic",
    query: {
      q,
      per_page,
      page,
      exclude_topic,
      dedupe,
    },
  });
}

/**
 * 喜欢主题
 * @param {{
 *  urlname: string[] | string
 * }} query
 * @returns
 */
export async function likeTopic({ urlname }) {
  return request({
    method: "post",
    url: `/topics/${urlname}/like`,
  });
}

/**
 * 取消喜欢主题
 * @param {{
 *  urlname: string[] | string
 * }} query
 * @returns
 */
export async function unlikeTopic({ urlname }) {
  return request({
    method: "delete",
    url: `/topics/${urlname}/like`,
  });
}

/**
 * 关注主题
 * @param {{
 *  urlname: string[] | string
 * }} query
 * @returns
 */
export async function followTopic({ urlname }) {
  return request({
    method: "post",
    url: `/topics/${urlname}/follow`,
  });
}

/**
 * 取消关注主题
 * @param {{
 *  urlname: string[] | string
 * }} query
 * @returns
 */
export async function unfollowTopic({ urlname }) {
  return request({
    method: "delete",
    url: `/topics/${urlname}/follow`,
  });
}

/**
 * 获取喜欢的主题
 * @param {{
 *  urlname: string[] | string
 *  max?: number
 *  since?: number
 *  limit?: number
 * }} query
 * @returns
 */
export async function getLikedTopics({ urlname, max, since, limit }) {
  return request({
    url: `/${urlname}/likes/topics`,
    query: {
      max,
      since,
      limit,
    },
  });
}

/**
 * 获取用户关注的主题
 * @param {{
 *  urlname: string[] | string
 *  max?: number
 *  since?: number
 *  limit?: number
 * }} query
 * @returns
 */
export async function getFollowingTopics({ urlname, max, since, limit }) {
  return request({
    url: `/${urlname}/following/topics`,
    query: {
      max,
      since,
      limit,
    },
  });
}
